import { Control, useFormContext } from 'react-hook-form';
import {
    Box,
    FormSelector,
    Icon,
    PargodaRoundButton,
    useTheme,
    IOption,
    useAppDispatch,
} from '../../../../../base';
import {
    IJobQuestionsForm,
    JobQuestionsFormFields,
} from '../../../../../common';
import { useTranslation } from 'react-i18next';
import {
    StyledPageHeader,
    StyledTopControlsContainer,
} from '../JobQuestions.styles';
import { useEffect } from 'react';

interface JobQuestionActionsProps {
    control: Control<IJobQuestionsForm>;
    jobsList: IOption[];
    onAddQuestion: () => void;
}

export const JobQuestionActions = ({
    control,
    jobsList,
    onAddQuestion,
}: JobQuestionActionsProps) => {
    const methods = useFormContext<IJobQuestionsForm>();
    const { watch } = methods;
    const { t } = useTranslation();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const watchedSelectedJob = watch(JobQuestionsFormFields.SELECTED_JOB);

    useEffect(() => {
        if (watchedSelectedJob?.value) {
            console.log('Selected job for questions:', watchedSelectedJob);
            // dispatch(jobsActions.fetchQuestions({ jobId: watchedSelectedJob.value }));
        }
    }, [watchedSelectedJob, dispatch]);

    return (
        <StyledPageHeader>
            <Box sx={{ width: '300px' }}>
                <FormSelector
                    name={JobQuestionsFormFields.SELECTED_JOB}
                    control={control}
                    options={jobsList}
                    size="small"
                    label={t('saveJob.selectFromExistingJob')}
                    placeholder={t('saveJob.selectJobToCopyFrom')}
                />
            </Box>
            <StyledTopControlsContainer>
                <PargodaRoundButton
                    variant="contained"
                    onClick={onAddQuestion}
                    startIcon={<Icon name="AddRoundedIcon" />}
                    sx={{
                        background: `linear-gradient(0deg,${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        width: '180px',
                    }}
                >
                    {t('saveJob.addQuestion')}
                </PargodaRoundButton>
            </StyledTopControlsContainer>
        </StyledPageHeader>
    );
};
